import React from 'react';
import {
  Button,
  useMediaQuery,
  useTheme
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useNavigate } from 'react-router-dom';
import { IdeaDraft, IdeaData } from '../../hooks/useIdeaResults';

interface IdeaSimulationRunnerProps {
  draft: IdeaDraft;
  ideaData: IdeaData;
  ideaId: string | undefined;
}

const IdeaSimulationRunner: React.FC<IdeaSimulationRunnerProps> = ({
  draft,
  ideaData,
  ideaId
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleRunSimulation = () => {
    navigate(`/simulations/create?fromIdeaDraft=${draft.id}&ideaId=${ideaId}`, {
      state: {
        prefill: {
          content: draft.text,
          platform: ideaData.platform,
          brand: ideaData.brand,
          sector: ideaData.sector,
          mediaDescription: draft.imageIdea || '',
          ideaDraftId: draft.id
        }
      }
    });
  };

  if (isMobile) {
    return (
      <Button 
        variant="contained" 
        color="primary" 
        size="medium"
        fullWidth
        startIcon={<PlayArrowIcon />}
        onClick={handleRunSimulation}
        sx={{ 
          py: 1.5,
          fontSize: '0.875rem',
          fontWeight: 600
        }}
      >
        Run Full Simulation
      </Button>
    );
  }

  return (
    <Button 
      variant="contained" 
      color="primary" 
      size="medium"
      startIcon={<PlayArrowIcon />}
      onClick={handleRunSimulation}
    >
      Run Full Simulation
    </Button>
  );
};

export default IdeaSimulationRunner;